"use client";

import { TooltipContentProps } from "recharts";
import { UStyles } from "@/app/utils/UStyles";
import { formatDay, TOOLTIP_SEPARATOR } from "./AnalysisOverview.logic";
import styles from "./AnalysisOverview.module.css";

export default function TimelineTooltip(props: TooltipContentProps) {
  const { active, payload, label } = props;
  const entry = payload?.[0];
  const value = Number(entry?.value);

  if (!active || !Number.isFinite(value)) {
    return null;
  }

  return (
    <div className={UStyles.classNames(styles.tooltip, styles.tooltipStack)}>
      <span className={styles.tooltipLabel}>{formatDay(label)}</span>
      <span className={styles.tooltipRow}>
        <span className={styles.tooltipName}>
          {String(entry?.name)}
          {TOOLTIP_SEPARATOR}
        </span>
        <span className={UStyles.classNames(styles.tooltipValue, styles.tooltipScore)}>
          {value}
        </span>
      </span>
    </div>
  );
}
